var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-success"},[_c('div',{staticClass:"service-form-success-icon"},[_c('z-icon',{attrs:{"class-prefix":"zziconfont","name":"check"}})],1),_c('p',[_vm._v("地址修改成功后，")]),_c('p',[_vm._v("快递会先寄送到原地址，")]),_c('p',[_vm._v("然后转运至新地址，请持续关注物流信息")])])
}
var staticRenderFns = []

export { render, staticRenderFns }